import Modal from "@shared/components/ui-kit/overlays/Modal/Modal.web";
import useMediaQuery from "@shared/hooks/useMediaQuery/useMediaQuery";
import { AuthProfileSerializer } from "@shared/modules/auth/serializer-types";
import { useTranslation } from "@shared/utils/internationalization";
import React, { useState } from "react";
import ContactDetails from "./ContactDetails";

// pass in EITHER isOpen/setIsOpen OR currentModal/setCurrentModal to control opening and closing this modal
type ContactDetailsModalSelectionProps = {
  venueId?: number;
  isOpen?: boolean;
  onClose: () => void;
  user?: AuthProfileSerializer;
  isLoggedIn: boolean;
  refundPolicyText?: string;
};

const ContactDetailsModalSelection: React.FC<
  ContactDetailsModalSelectionProps
> = ({
  venueId = undefined,
  isOpen = false,
  onClose,
  user = undefined,
  isLoggedIn,
  refundPolicyText = null,
}): JSX.Element => {
  const { t } = useTranslation("account");
  const [displaySingleCol] = useMediaQuery(`(max-width: 920px)`);
  const [allowMessageFromCustomers, setAllowMessageFromCustomers] =
    useState(true);

  return (
    <Modal
      scrollBehavior="inside"
      size={displaySingleCol || !allowMessageFromCustomers ? "2xl" : "4xl"}
      isOpen={isOpen}
      isCentered
      data-testid="default-modal-container-wrapper"
      variant="informational"
      onClose={onClose}
    >
      <Modal.Header>{t("Contact Details")}</Modal.Header>
      <Modal.Body>
        <ContactDetails
          venueId={venueId}
          displaySingleCol={displaySingleCol}
          onClose={onClose || null}
          user={user}
          isLoggedIn={isLoggedIn}
          setAllowsMessage={setAllowMessageFromCustomers}
          refundPolicyText={refundPolicyText}
        />
      </Modal.Body>
    </Modal>
  );
};

export default ContactDetailsModalSelection;
